var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-companion-overlay",
      class: [
        _vm.showCompanion ? "cw-companion-overlay-in" : "",
        _vm.showCompanion ? "" : "cw-companion-overlay-out",
        _vm.styleCompanion
      ]
    },
    [
      _c("div", {
        staticClass: "cw-companion-overlay-content",
        domProps: {
          innerHTML: _vm._s(_vm.msgCompanion)
        }
      }),
      _vm._v(" "),
      _c("button", {
        staticClass: "cw-compantion-overlay-close",
        on: {
          click: _vm.hideCompanion
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }